export const PageHeaders = {
    vehicle: { header: "Admin Tools", sub_header: "Vehicle List" }
}
